import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleQuestion, Hourglass, PartyPopper, Heart, Camera, Video, Share2 } from 'lucide-react';
import { CARD_RISE } from './data';

const BEATS = [
  {
    icon: Hourglass,
    tag: 'The tease',
    text: '"It\'s your birthday week. Someone from your Tuesday football team sent you a surprise."',
  },
  {
    icon: MessageCircleQuestion,
    tag: 'The build',
    text: 'The group chat lights up: "OK WHICH ONE OF YOU IS IT?" Screenshots fly. Everyone denies it.',
  },
  {
    icon: PartyPopper,
    tag: 'The reveal',
    text: 'It opens itself. A 20-second video — it was Tom all along. Then the photos, the message, and (because he added one) a gift card to her favourite shop.',
  },
  {
    icon: Heart,
    tag: 'The memory',
    text: '"I can\'t believe he remembered." A forgettable thing, made unforgettable.',
  },
];

export const GuessingGame = () => (
  <section id="story" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32" data-testid="guessing-game-section">
    <div className="mx-auto max-w-2xl text-center">
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">The guessing game</p>
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        Mystery. Anticipation. <span className="text-primary">Reveal. Joy.</span>
      </h2>
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">
        Here's how one birthday unfolded — and why the reveal is the part they'll talk about.
      </p>
    </div>
    <div className="mt-14 grid gap-5 md:grid-cols-4">
      {BEATS.map((beat, i) => (
        <motion.div
          key={beat.tag}
          {...CARD_RISE}
          transition={{ duration: 0.5, delay: i * 0.12 }}
          className="relative rounded-2xl border border-border bg-card p-7 shadow-sm"
          data-testid={`story-beat-${i + 1}`}
        >
          <div className="flex items-center justify-between">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <beat.icon className="h-5 w-5" />
            </div>
            <span className="font-display text-5xl font-bold leading-none text-foreground/[0.06]">{i + 1}</span>
          </div>
          <h3 className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-primary">{beat.tag}</h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground/80">{beat.text}</p>
        </motion.div>
      ))}
    </div>
    <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-semibold text-muted-foreground">
      <span className="flex items-center gap-2"><Camera className="h-4 w-4 text-primary" /> Screenshotable</span>
      <span className="flex items-center gap-2"><Video className="h-4 w-4 text-primary" /> Video-native</span>
      <span className="flex items-center gap-2"><Share2 className="h-4 w-4 text-primary" /> Made to be shared</span>
    </div>
  </section>
);
